// Date-only helpers for the Task Manager weekly board (no time component).

const pad = (n) => String(n).padStart(2, '0');

/** 'YYYY-MM-DD' for a Date (local). */
export const toYMD = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;

/** Parse 'YYYY-MM-DD' to a local Date at midnight. */
export const fromYMD = (s) => {
  const [y, m, d] = String(s).slice(0, 10).split('-').map(Number);
  return new Date(y, m - 1, d);
};

export const todayYMD = () => toYMD(new Date());

/** Monday of the week containing `date`. */
export const startOfWeek = (date) => {
  const d = new Date(date);
  const day = d.getDay();              // 0=Sun … 6=Sat
  const diff = day === 0 ? -6 : 1 - day; // back to Monday
  d.setDate(d.getDate() + diff);
  d.setHours(0, 0, 0, 0);
  return d;
};

export const addDays = (date, n) => {
  const d = new Date(date);
  d.setDate(d.getDate() + n);
  return d;
};

/** The five weekday Dates (Mon–Fri) starting from a Monday. */
export const weekdays = (monday) => Array.from({ length: 5 }, (_, i) => addDays(monday, i));

export const startOfMonth = (date) => new Date(date.getFullYear(), date.getMonth(), 1);
export const endOfMonth   = (date) => new Date(date.getFullYear(), date.getMonth() + 1, 0);

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const DAYS   = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

export const dayLabel  = (d) => DAYS[(d.getDay() + 6) % 7];
export const dayNum    = (d) => d.getDate();
export const monthName = (d) => MONTHS[d.getMonth()];

/** "23 – 27 Jun 2026" (or spanning months/years). */
export const weekRangeLabel = (monday) => {
  const fri = addDays(monday, 4);
  const sameMonth = monday.getMonth() === fri.getMonth();
  const sameYear  = monday.getFullYear() === fri.getFullYear();
  if (sameMonth && sameYear) return `${monday.getDate()} – ${fri.getDate()} ${MONTHS[fri.getMonth()]} ${fri.getFullYear()}`;
  if (sameYear)              return `${monday.getDate()} ${MONTHS[monday.getMonth()]} – ${fri.getDate()} ${MONTHS[fri.getMonth()]} ${fri.getFullYear()}`;
  return `${monday.getDate()} ${MONTHS[monday.getMonth()]} ${monday.getFullYear()} – ${fri.getDate()} ${MONTHS[fri.getMonth()]} ${fri.getFullYear()}`;
};

export const isSameDay = (a, b) => toYMD(a) === toYMD(b);
export const isWeekend = (d) => { const g = d.getDay(); return g === 0 || g === 6; };
